var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorSoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 53,
    viewBox: "0 0 47 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0273 20.6455L8.61598 10.3471C8.4305 9.56349 8.91275 8.81722 9.65471 8.63065L25.5695 4.82471L34.5842 10.9814L40.223 33.6306C40.4086 34.4141 39.9262 35.1604 39.1842 35.3469L17.2226 40.5708C16.4435 40.7573 15.7016 40.2722 15.5161 39.5259L10.8418 19.8619",
    fill: "url(#paint0_linear_316_25802)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8144 19.9364L30.319 41.6526C30.0222 42.3988 29.2061 42.7348 28.4641 42.4364L7.57829 33.8542C6.83633 33.5558 6.50248 32.7347 6.79925 31.9885L18.0398 4.22751C18.3365 3.48124 19.1527 3.14542 19.8946 3.44391L35.0674 9.67523L38.8144 19.9364Z",
    fill: "url(#paint1_linear_316_25802)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_316_25802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6245 37.4738C36.6245 38.2576 35.9941 38.892 35.2148 38.892H12.6597C11.8806 38.892 11.25 38.2576 11.25 37.4738V7.47404C11.25 6.69047 11.8806 6.05615 12.6597 6.05615H29.0196L36.365 14.1531L36.5132 27.7352L36.6245 37.4738Z",
    fill: "url(#paint2_linear_316_25802)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4701 30.3097H18.9295C18.707 30.3097 18.5215 30.1231 18.5215 29.8992C18.5215 29.6753 18.707 29.4888 18.9295 29.4888H32.4701C32.6927 29.4888 32.8783 29.6753 32.8783 29.8992C32.841 30.1231 32.6927 30.3097 32.4701 30.3097Z",
    fill: "#5E6A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2608 30.3097H14.8866C14.664 30.3097 14.4785 30.1231 14.4785 29.8992C14.4785 29.6753 14.664 29.4888 14.8866 29.4888H17.2608C17.4834 29.4888 17.6689 29.6753 17.6689 29.8992C17.6689 30.1231 17.4834 30.3097 17.2608 30.3097Z",
    fill: "#5E6A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4333 26.6153H26.3866C26.164 26.6153 25.9785 26.4288 25.9785 26.2049C25.9785 25.981 26.164 25.7944 26.3866 25.7944H32.4333C32.6562 25.7944 32.8415 25.981 32.8415 26.2049C32.8045 26.466 32.6562 26.6153 32.4333 26.6153Z",
    fill: "#5E6A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8252 26.6153H14.996C14.7734 26.6153 14.5879 26.4288 14.5879 26.2049C14.5879 25.981 14.7734 25.7944 14.996 25.7944H23.8252C24.0477 25.7944 24.2332 25.981 24.2332 26.2049C24.2332 26.466 24.0477 26.6153 23.8252 26.6153Z",
    fill: "#5E6A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5441 22.9586H30.2069C29.9843 22.9586 29.7988 22.772 29.7988 22.5481C29.7988 22.3243 29.9843 22.1377 30.2069 22.1377H32.5441C32.7666 22.1377 32.9522 22.3243 32.9522 22.5481C32.9522 22.772 32.7666 22.9586 32.5441 22.9586Z",
    fill: "#5E6A80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0172 22.9586H15.1073C14.8847 22.9586 14.6992 22.772 14.6992 22.5481C14.6992 22.3243 14.8847 22.1377 15.1073 22.1377H28.0172C28.2398 22.1377 28.4252 22.3243 28.4252 22.5481C28.4252 22.772 28.2398 22.9586 28.0172 22.9586Z",
    fill: "#5E6A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2301 34.3392H21.4139C21.1914 34.3392 21.0059 34.1524 21.0059 33.9286C21.0059 33.7049 21.1914 33.5181 21.4139 33.5181H22.2301C22.4527 33.5181 22.6382 33.7049 22.6382 33.9286C22.6011 34.1524 22.4156 34.3392 22.2301 34.3392Z",
    fill: "#5E6A80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.93 34.3392H15.1073C14.8847 34.3392 14.6992 34.1524 14.6992 33.9286C14.6992 33.7049 14.8847 33.5181 15.1073 33.5181H19.8929C20.1154 33.5181 20.3009 33.7049 20.3009 33.9286C20.338 34.1524 20.1525 34.3392 19.93 34.3392Z",
    fill: "#5E6A80"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6554 19.3018H24.3456C24.123 19.3018 23.9375 19.1153 23.9375 18.8914C23.9375 18.6675 24.123 18.481 24.3456 18.481H32.6554C32.878 18.481 33.0636 18.6675 33.0636 18.8914C33.0636 19.1153 32.878 19.3018 32.6554 19.3018Z",
    fill: "#5E6A80"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6736 19.3018H15.2186C14.996 19.3018 14.8105 19.1153 14.8105 18.8914C14.8105 18.6675 14.996 18.481 15.2186 18.481H21.6365C21.8591 18.481 22.0445 18.6675 22.0445 18.8914C22.0445 19.1153 21.8961 19.3018 21.6736 19.3018Z",
    fill: "#5E6A80"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1995 11.0184H15.367C15.0702 11.0184 14.8477 10.7945 14.8477 10.496C14.8477 10.1975 15.0702 9.97363 15.367 9.97363H26.1995C26.4962 9.97363 26.7188 10.1975 26.7188 10.496C26.7188 10.7572 26.4591 11.0184 26.1995 11.0184Z",
    fill: "#E53E3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4848 13.6307H15.367C15.0702 13.6307 14.8477 13.4068 14.8477 13.1083C14.8477 12.8098 15.0702 12.5859 15.367 12.5859H19.5219C19.8187 12.5859 20.0413 12.8098 20.0413 13.1083C20.0042 13.3695 19.7816 13.6307 19.4848 13.6307Z",
    fill: "#E53E3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0195 6.05566V12.4735C29.0195 13.369 29.7986 14.1153 30.6891 14.1153H36.3648",
    fill: "#D1DAE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8646 34.4157C42.8646 35.4697 42.689 36.4359 42.2936 37.3581C41.4153 39.6418 39.5268 41.3985 37.1993 42.189C36.4087 42.4526 35.5743 42.5841 34.6959 42.5841C30.1725 42.5841 26.5273 38.9392 26.5273 34.4157C26.5273 29.8922 30.1725 26.2471 34.6959 26.2471C39.2194 26.2471 42.8646 29.9361 42.8646 34.4157Z",
    fill: "url(#paint3_linear_316_25802)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_25802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5009 35.8745C34.3686 35.8745 34.2641 35.8324 34.1875 35.7483C34.1178 35.6572 34.083 35.5381 34.083 35.3909C34.083 35.0686 34.1422 34.7672 34.2606 34.4869C34.386 34.2066 34.595 33.9018 34.8876 33.5724C35.1105 33.3271 35.2638 33.1169 35.3474 32.9417C35.4379 32.7665 35.4832 32.5808 35.4832 32.3845C35.4832 32.1533 35.3996 31.9711 35.2324 31.8379C35.0652 31.7048 34.8284 31.6382 34.5218 31.6382C34.2432 31.6382 33.9889 31.6768 33.759 31.7538C33.5361 31.8239 33.3097 31.9255 33.0798 32.0587C32.8917 32.1708 32.7245 32.2094 32.5782 32.1743C32.4389 32.1323 32.3379 32.0482 32.2752 31.922C32.2125 31.7959 32.202 31.6557 32.2438 31.5016C32.2856 31.3474 32.3971 31.2107 32.5782 31.0916C32.8638 30.9024 33.1913 30.7587 33.5605 30.6606C33.9297 30.5555 34.278 30.5029 34.6054 30.5029C35.0443 30.5029 35.4275 30.5765 35.7549 30.7237C36.0893 30.8708 36.3471 31.0741 36.5282 31.3334C36.7163 31.5927 36.8103 31.8975 36.8103 32.2479C36.8103 32.5702 36.7372 32.8716 36.5909 33.1519C36.4516 33.4322 36.2008 33.7371 35.8385 34.0664C35.5111 34.3678 35.2847 34.6271 35.1593 34.8443C35.0339 35.0616 34.9538 35.2928 34.9189 35.5381C34.912 35.6362 34.8702 35.7168 34.7935 35.7799C34.7239 35.8429 34.6263 35.8745 34.5009 35.8745ZM34.48 38.0714C34.2432 38.0714 34.0516 37.9979 33.9053 37.8507C33.766 37.7035 33.6963 37.5143 33.6963 37.2831C33.6963 37.0588 33.766 36.8766 33.9053 36.7364C34.0516 36.5893 34.2432 36.5157 34.48 36.5157C34.7239 36.5157 34.912 36.5893 35.0443 36.7364C35.1837 36.8766 35.2533 37.0588 35.2533 37.2831C35.2533 37.5143 35.1837 37.7035 35.0443 37.8507C34.912 37.9979 34.7239 38.0714 34.48 38.0714Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_316_25802",
    x: 4.57903,
    y: 2.72067,
    width: 38.7169,
    height: 46.1779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.33548
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.33548
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_316_25802"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_316_25802",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_25802",
    x1: 24.4091,
    y1: 3.99693,
    x2: 24.4091,
    y2: 40.9966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_25802",
    x1: 22.7424,
    y1: 2.4285,
    x2: 22.7424,
    y2: 42.9674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_316_25802",
    x1: 23.929,
    y1: 5.29664,
    x2: 23.929,
    y2: 39.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#E5EAF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_316_25802",
    x1: 34.6906,
    y1: 25.8692,
    x2: 34.6906,
    y2: 42.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EEADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3CB5AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_25802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.85161,
    height: 7.88387,
    fill: "white",
    transform: "translate(32.1426 30.3228)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSoal);
export default __webpack_public_path__ + "static/media/errorSoal.cca3b36cdd5a8737abb9f8f4be130f3e.svg";
export { ForwardRef as ReactComponent };